<template>
  <div>
    <div
      class="modal fade share-print-modal"
      id="sharePrintModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sharePrintModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
      ref="sharePrintModal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content sp-modal-content">
          <!-- Header -->
          <div class="sp-header">
            <div class="sp-header-icon">
              <i class="material-icons">share</i>
            </div>
            <div class="sp-header-text">
              <h5 id="sharePrintModalLabel">Share &amp; Print Fields</h5>
              <p>Choose which patient fields appear on shared &amp; printed documents</p>
            </div>
            <button type="button" class="close d-close" @click="closeModal" data-dismiss="modal">
              <i class="material-icons">close</i>
            </button>
          </div>

          <!-- Body -->
          <div class="sp-body">
            <div class="sp-section-label">PATIENT FIELDS</div>

            <div class="sp-toggle-list">
              <!-- Mobile Number -->
              <div class="sp-toggle-row" :class="{ 'sp-disabled': saving }">
                <div class="sp-toggle-info">
                  <span class="sp-icon mobile-icon"></span>
                  <div>
                    <div class="sp-name">Mobile Number</div>
                    <div class="sp-desc">Show patient mobile number on shares &amp; prints</div>
                  </div>
                </div>
                <label class="sp-switch">
                  <input
                    type="checkbox"
                    v-model="settings.mobileNumber"
                    @change="onToggle('mobileNumber')"
                    :disabled="saving"
                  />
                  <span class="sp-slider"></span>
                </label>
              </div>

              <!-- Address -->
              <div class="sp-toggle-row" :class="{ 'sp-disabled': saving }">
                <div class="sp-toggle-info">
                  <span class="sp-icon address-icon"></span>
                  <div>
                    <div class="sp-name">Address</div>
                    <div class="sp-desc">Show patient address on shares &amp; prints</div>
                  </div>
                </div>
                <label class="sp-switch">
                  <input
                    type="checkbox"
                    v-model="settings.address"
                    @change="onToggle('address')"
                    :disabled="saving"
                  />
                  <span class="sp-slider"></span>
                </label>
              </div>

              <!--
                To add another field (e.g. Email, DOB, Gender):
                1. Add a key + default to `settings` in data()
                2. Add a matching toggle-row block above
                3. Add it to loadFromStorage() / saveSettings() mapping below
              -->
            </div>

            <!-- Save feedback -->
            <transition name="sp-fade">
              <div v-if="saveMessage" class="sp-save-feedback" :class="saveMessageType">
                <i class="material-icons">{{ saveMessageType === 'success' ? 'check_circle' : 'error' }}</i>
                {{ saveMessage }}
              </div>
            </transition>
          </div>

          <!-- Footer -->
          <div class="sp-footer">
            <span class="sp-footer-note">
              <i class="material-icons">info</i>
              Changes apply immediately for all users on reload
            </span>
            <div class="sp-footer-actions">
              <button class="sp-btn-save primary-btn ripple" @click="saveSettings" :disabled="saving">
                <span v-if="saving">
                  <i class="material-icons sp-spin">autorenew</i> Saving…
                </span>
                <span v-else>Save Changes</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import rest_service from "../../api/rest_service";

export default {
  name: "ShareAndPrintSettings",
  props: {
    showmodal: {
      type: Boolean,
      default: false,
    },
    parentprop: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      settings: {
        mobileNumber: false,
        address: false,
      },
      // snapshot of last-saved state so Close can revert unsaved toggles
      savedSettings: {},
      saving: false,
      saveMessage: "",
      saveMessageType: "success",
      _saveMessageTimer: null,
    };
  },
  watch: {
    showmodal(val) {
      if (val) {
        this.loadFromStorage();
        this.$nextTick(() => {
          $(this.$refs.sharePrintModal).modal("show");
        });
      } else {
        $(this.$refs.sharePrintModal).modal("hide");
      }
    },
  },
  mounted() {
    const self = this;
    $(this.$refs.sharePrintModal).on("hidden.bs.modal", function () {
      if (self.parentprop) {
        // Mirror the pattern used by every other popup in this codebase:
        // reset the controlling flag on the parent so re-opening works correctly.
        self.parentprop.opencloseSharePrintModal = false;
      }
      self.$emit("close");
    });
  },
  beforeDestroy() {
    clearTimeout(this._saveMessageTimer);
    $(this.$refs.sharePrintModal).modal("hide");
  },
  methods: {
    // ─── Read current state from localStorage ──────────────────────────────
    // Stored shape (mirrors DynamoDB BusinessSetup.ShareAndPrintSections):
    //   "ShareAndPrintSections": { "SS": ["address", "mobileNumber"] }
    // A field's presence in the SS list means it's enabled. If the key is
    // absent entirely (never configured), default everything to enabled.
    loadFromStorage() {
        debugger
      const raw = window.localStorage.getItem("tenantbusinesssetup");
      if (!raw) return;
      try {
        const setup = JSON.parse(raw);
        const hasSection = setup.shareAndPrintSections && Array.isArray(setup.shareAndPrintSections);
        const enabledSections = hasSection ? setup.shareAndPrintSections : ["mobileNumber", "address"];

        this.settings = {
          mobileNumber: enabledSections.includes("mobileNumber"),
          address:      enabledSections.includes("address"),
        };
        // deep-copy as saved baseline
        this.savedSettings = { ...this.settings };
      } catch (e) {
        console.error("ShareAndPrintSettings: failed to parse tenantbusinesssetup", e);
      }
    },

    // ─── Called on every individual toggle (optional immediate UX feedback) ─
    onToggle(key) {
      // No-op for now – all saves are deferred to Save Changes.
      // Extend here if you want auto-save behaviour per toggle.
    },

    // ─── Persist to localStorage + API ──────────────────────────────────────
    saveSettings() {
      this.saving = true;
      this.saveMessage = "";
        debugger
      try {
        const raw = window.localStorage.getItem("tenantbusinesssetup");
        const setup = raw ? JSON.parse(raw) : {};

        // Build the enabled-sections list in the DynamoDB SS shape
        const sections = [];
        if (this.settings.mobileNumber) sections.push("mobileNumber");
        if (this.settings.address) sections.push("address");

        const updated = {
          ...setup,
          shareAndPrintSections: sections
        };

        window.localStorage.setItem("tenantbusinesssetup", JSON.stringify(updated));

        // ── Propagate to parent so share/print views can react immediately ──
        if (this.parentprop) {
          this.parentprop.isMobileNumberVisible = this.settings.mobileNumber;
          this.parentprop.isAddressVisible = this.settings.address;
        }

        this.savedSettings = { ...this.settings };
        this.showFeedback("Settings saved successfully", "success");
        this.persistToAPI(sections);

      } catch (e) {
        console.error("ShareAndPrintSettings: save failed", e);
        this.showFeedback("Save failed. Please try again.", "error");
      } finally {
        this.saving = false;
        setTimeout(
          function () {
            $(this.$refs.sharePrintModal).modal("hide");
          }.bind(this),
          3000
        );
      }
    },

    // ─── API call ────────────────────────────────────────────────────────
    // Matches UpdateShareAndPrintSectionsRequest: { "Sections": ["address", "mobileNumber"] }
    // NOTE: adjust the URL prefix below ("staff/") if this endpoint lives under
    // a different controller route in your API.
    persistToAPI(sections) {
      const provider  = JSON.parse(localStorage.getItem("loggedInUserInfo") || "{}");
      const token     = localStorage.getItem("accesstoken") || "";
      const headers   = {
        x_tenant_id:              provider.tenant_id,
        role_unique_id:           provider.role.unique_id,
        loggedin_user_unique_id:  provider.unique_id,
        Authorization:            token,
      };
      return Axios.put(
        `${rest_service.baseURL}/staff/shareandprintsections`,
        { Sections: sections },
        { headers }
      ).catch(err => console.warn("ShareAndPrintSettings: API persist failed", err));
    },

    // ─── Transient feedback banner ──────────────────────────────────────────
    showFeedback(msg, type = "success") {
      clearTimeout(this._saveMessageTimer);
      this.saveMessage     = msg;
      this.saveMessageType = type;
      this._saveMessageTimer = setTimeout(() => { this.saveMessage = ""; }, 3500);
    },

    closeModal() {
      // Revert uncommitted toggle changes
      this.settings = { ...this.savedSettings };
      $(this.$refs.sharePrintModal).modal("hide");
    },
  },
};
</script>

<style scoped>
@keyframes sp-spin {
  to { transform: rotate(360deg); }
}
/* ── Modal shell ─────────────────────────────────────────────────────────── */
.sp-modal-content {
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  font-family: inherit;
  min-width: 460px;
}

/* ── Header ──────────────────────────────────────────────────────────────── */
.sp-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 24px 16px;
  color: #000;
}

.sp-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sp-header-icon .material-icons {
  font-size: 22px;
}

.sp-header-text {
  flex: 1;
}

.sp-header-text h5 {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.sp-header-text p {
  margin: 0;
  font-size: 12px;
  color: #000;
}

.sp-close-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: background 0.15s;
}

.sp-close-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

/* ── Body ────────────────────────────────────────────────────────────────── */
.sp-body {
  padding: 20px 24px 12px;
  background: #f8f9fb;
}

.sp-section-label {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #90a4ae;
  margin-bottom: 12px;
}

/* ── Toggle rows ─────────────────────────────────────────────────────────── */
.sp-toggle-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sp-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  padding: 12px 16px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.sp-toggle-row:hover {
  border-color: #90caf9;
  box-shadow: 0 2px 8px rgba(21, 101, 192, 0.07);
}

.sp-toggle-row.sp-disabled {
  opacity: 0.55;
  pointer-events: none;
}

.sp-toggle-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sp-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: inline-block;
  flex-shrink: 0;
  background-color: #e3f0fd;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 18px 18px;
}

.sp-icon.mobile-icon  { background-color: #e1f5fe; }
.sp-icon.address-icon { background-color: #fff3e0; }

.sp-name {
  font-size: 14px;
  font-weight: 600;
  color: #263238;
  line-height: 1.3;
}

.sp-desc {
  font-size: 11.5px;
  color: #78909c;
  margin-top: 1px;
}

/* ── iOS-style toggle switch ─────────────────────────────────────────────── */
.sp-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  margin: 0;
  flex-shrink: 0;
}

.sp-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.sp-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #cfd8dc;
  border-radius: 24px;
  transition: background 0.2s;
}

.sp-slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
  box-shadow: 0 1px 4px rgba(0,0,0,0.18);
}

.sp-switch input:checked + .sp-slider {
  background: #1565c0;
}

.sp-switch input:checked + .sp-slider::before {
  transform: translateX(20px);
}

/* ── Save feedback banner ─────────────────────────────────────────────────── */
.sp-save-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  margin-top: 14px;
}

.sp-save-feedback.success {
  background: #e8f5e9;
  color: #2e7d32;
}

.sp-save-feedback.error {
  background: #ffebee;
  color: #c62828;
}

.sp-save-feedback .material-icons {
  font-size: 17px;
}

/* ── Footer ──────────────────────────────────────────────────────────────── */
.sp-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px 18px;
  background: #fff;
  border-top: 1px solid #e8ecf0;
  gap: 12px;
}

.sp-footer-note {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  color: #90a4ae;
}

.sp-footer-note .material-icons {
  font-size: 15px;
}

.sp-footer-actions {
  display: flex;
  gap: 10px;
}

.sp-btn-save {
  min-width: 140px;
}

.sp-spin {
  font-size: 16px;
  animation: sp-spin 0.8s linear infinite;
}

/* ── Transition ──────────────────────────────────────────────────────────── */
.sp-fade-enter-active,
.sp-fade-leave-active {
  transition: opacity 0.25s;
}
.sp-fade-enter,
.sp-fade-leave-to {
  opacity: 0;
}
.modal-dialog.modal-dialog-centered{
  margin-top: 25px;
}
.modal-dialog .modal-content{
  padding-top: 0;
}
</style>